import { render } from "./SearchQuick.component.vue?vue&type=template&id=1beb1c98"
import script from "./SearchQuick.component.vue?vue&type=script&lang=js"
export * from "./SearchQuick.component.vue?vue&type=script&lang=js"

import "./SearchQuick.component.vue?vue&type=style&index=0&id=1beb1c98&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__